<template>
  <card :title="title">
    <load-block :load="load"></load-block>
    <div class="row">
      <div class="col-md-4">
        <label>{{label}}</label>
        <div class="form-group has-label">
          <div class="el-input">
            <v-select
              :label="labelSelect"
              v-model="selectCode"
              :options="option"
              @search="onSearch"
            >
              <span slot="no-options">{{$t('Результатов не найдено')}}</span>
            </v-select>

          </div>
        </div>

      </div>
      <div class="col-md-2">
        <label>&nbsp;</label>
        <l-button type="success" :disabled="!(selectCode && hasSave) " wide block @click="connectCode">{{$t('Привязать')}}</l-button>
      </div>
    </div>
  </card>
</template>
<script>
  import HttpClient from '../../../../util/HttpClient'
  import {api} from '../../../../util/api'
  import {API_METHODS} from '../../../../constant'
  import {CONTRACT_CONNECT} from '../store/type'
  import LoadBlock from "../../../shared/LoadBlock.vue";
  import {NAME_OBJECT, NAME_ACTION } from "../../../../RoleConstanans"

  export default {
    components: {LoadBlock},
    name: 'EditPagePlug',
    data() {
      return {
        selectCode: null,
        option: [],
        labelSelect: 'entityName',
        keyId: 'entityId',
        load: false,
        routeAdd : "ClientEditCodePersone",
        routeEdit: "ClientEditCodePersoneEdit",
        nameRule:  this.$route.name == 'addPolicy' ? NAME_OBJECT.policyContract :  NAME_OBJECT.commercialTermsContract,
        ChildType: this.$route.name == 'addPolicy' ? 'Policy' : 'FinancialCondition',
        label:     this.$route.name == 'addPolicy' ?  this.$t('Корпоративная политика') : this.$t('Коммерческие условия') ,
      }
    },
    created() {
      this.initData()
    },
    computed:{
       hasSave() {
        let nameRule = this.nameRule
        return this.userRoleLouded && this.isActionAccess(nameRule, NAME_ACTION.isCreate)
       },
      title(){
        return this.$route.name == 'addPolicy' ?
        this.$t('Привязать корпоративную политика к контракту') :
        this.$t('Привязать коммерческие условия к контракту')
      },
      userRoleLouded(){
        return this.$store.getters.userRoleLouded
      }
    },
    methods: {
      isActionAccess(name, actions){
        return this.$store.getters.isActionAccess(name, actions)
      },
      async initData() {
        this.load = true
        try {
          const res = await this.loadData()
          this.load = false
        } catch (e) {
          this.load = false
        }
      },
      async connectCode() {
        const paramsIn = {
          self: this,
          ContractId: this.$route.params.ContractId,
          id: this.selectCode[this.keyId],
          ChildType: this.ChildType,
        }
        this.load = true
        try {
          let res = await this.$store.dispatch(CONTRACT_CONNECT, paramsIn)
          this.load = false
          this.$router.push({path:`/contract/${this.$route.params.ContractId}/edit`});
        } catch (e) {
          console.error(e)
          this.load = false
        }
      },
      onSearch(search, loading, event) {
        if (search.length < 3)
          return false

        loading(true);
        this.search(loading, search, this);
      },
      search(loading, search, vm) {
        vm.loadData(null, search)
          .then(() => {
            loading(false)
          })
          .catch(() => {
            loading(false)
          })
      },
      async loadData(search = null) {
        try {
          const params = {
            self: this,
            ContractId: this.$route.params.ContractId,
            ChildType: this.ChildType,
            query: {
              search: search,
              lang: this.$store.state.common.lang,
            }
          }
          let res = await api(API_METHODS.GET_CHILD_TYPE_UNLINKED_CONTACT, params)
          let responseData = res.object
          if (!('map' in responseData)) {
            responseData = [responseData]
          }
          this.addOptions(responseData);
          return res
        } catch (err) {
          return err
        }

      },
      addOptions(result) {
        result.forEach(item => {
          let find = this.option.find(el => el[this.keyId] == item[this.keyId])
          if (!find) {
            this.option.push(item)
          }
        })
      },
    }
  }
</script>
